module.exports = function(){ /* empty */ };


/*****************
 ** WEBPACK FOOTER
 ** ../~/babel-runtime/~/core-js/library/modules/$.unscope.js
 ** module id = 48
 ** module chunks = 0
 **/